import { render, staticRenderFns } from "./overview-cell-exchange-action.vue?vue&type=template&id=2ed45095&scoped=true"
import script from "./overview-cell-exchange-action.vue?vue&type=script&lang=ts"
export * from "./overview-cell-exchange-action.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed45095",
  null
  
)

export default component.exports